import { Injectable } from "@angular/core";
import { IntakeService } from "app/intake/intake-services/intake.service";
import { UserProfile } from "app/_models";
import { CalamityActionHistoryModel } from "./models/calamity-action-history.model";
import { DatePipe } from '@angular/common';

@Injectable({
    providedIn: 'root',
})

export class CalamityActionHistoryService {
    public profile: UserProfile = new UserProfile();

    constructor(private intakeService : IntakeService ) {
      }
    
    getDate(date){
        return this.getLocaleDate(date);
       }
     
       getLocaleDate(date: Date) {
         if(date!=null && (this.isIsoDate(date.toString()) ||  date.toString().indexOf('GMT') ==-1 ))
         {
           return this.intakeService.getLocalDate(date);
         }
         return date;
       }
     
       isIsoDate(dateStringToCompare) {
         return new Date(dateStringToCompare).toISOString() === dateStringToCompare;
      }

    public getfieldsChanged(oldValues, newValues): any[] {
        let actionHistoryList : any[] = [];
        Object.keys(oldValues).forEach(el1 => {
            if (el1 != "claId" && el1 != "claCalamityId" && el1 != "claLineNumber"
             && el1 != "claTimeStamp" && el1 != "claRoleCodeId" && el1 != "claCreatedBy"
             && el1 != "claCreatedDate"  && el1 != "claLastModifiedBy"  && el1 != "claLastModifiedDate"
            ) {
                Object.keys(newValues).forEach(el2 => {
                    if (el1 == "claFollowUpDate" && el1 == el2 && oldValues[el1] != newValues[el2] ) {
                        let oldValue = null;
                        let newValue = null;
                        let oldFollowUpDate = null;
                        let newFollowUpDate = null ;
                        if(oldValues[el1]!=null){
                            oldValue = this.getDate (oldValues[el1]);
                            if (oldValue != null && oldValue != undefined){
                                let hoursDiff = oldValue.getHours() - oldValue.getTimezoneOffset() / 60;
                                oldValue.setHours(hoursDiff);
                                oldFollowUpDate =  oldValue.toUTCString();
                                oldFollowUpDate = oldFollowUpDate.substring(0, oldFollowUpDate.length-3);
                            }  
                        }
                        if(newValues[el2]!=null){
                            newValue = new Date (newValues[el2]);
                            if(newValue != null && newValue != undefined){
                                let hoursDiff1 = newValue.getHours() - newValue.getTimezoneOffset() / 60;
                                newValue.setHours(hoursDiff1);
                                newFollowUpDate =  newValue.toUTCString();
                                newFollowUpDate= newFollowUpDate.substring(0, newFollowUpDate.length-3);
                            }
                        }

                        if((oldValue != null && newValue != null && oldValue.getTime() != newValue.getTime()) || oldValue == null || newValue == null){
                            let actionHistory = new CalamityActionHistoryModel();
                            let dalFreeText = {
                                user: this.profile.fullName,
                                action: "has updated",
                                field: "FollowUpDate",
                                oldvalue: oldFollowUpDate,
                                newvalue: newFollowUpDate,
                                date: new Date()
                            };
                            actionHistory.calFreeText = JSON.stringify(dalFreeText);
                            actionHistory.calCreatedBy = this.profile.fullName;
                            actionHistory.calCreatedDate = new Date();
                            actionHistory.calLastModifiedDate = new Date();
                            actionHistoryList.push(actionHistory);
                        }
                    }

                    if (el1 == "claActionType" && el1 == el2 && oldValues[el1].atLongName != newValues[el2].atLongName) {
                        let actionHistory = new CalamityActionHistoryModel();
                        let dalFreeText = {
                            user: this.profile.fullName,
                            action: "has updated",
                            field: "ActionType",
                            oldvalue: oldValues[el1].atShortName,
                            newvalue: newValues[el2].atShortName,
                            date: new Date()
                        };
                        actionHistory.calFreeText = JSON.stringify(dalFreeText);
                        actionHistory.calCreatedBy = this.profile.fullName;
                        actionHistory.calCreatedDate = new Date();
                        actionHistory.calLastModifiedDate = new Date();
                        actionHistoryList.push(actionHistory);
                    }

                   else if (el1 == "claStatus" && el1 == el2 && oldValues[el1].dasShortName != newValues[el2].dasShortName) {
                        let actionHistory = new CalamityActionHistoryModel();
                        let dalFreeText = {
                            user: this.profile.fullName,
                            action: "has updated",
                            field: "Status",
                            oldvalue: oldValues[el1].dasShortName,
                            newvalue: newValues[el2].dasShortName,
                            date: new Date()
                        };
                        actionHistory.calFreeText = JSON.stringify(dalFreeText);
                        actionHistory.calCreatedBy = this.profile.fullName;
                        actionHistory.calCreatedDate = new Date();
                        actionHistory.calLastModifiedDate = new Date();
                        actionHistoryList.push(actionHistory);
                    }
                    
                    else if (el1 == "claAgenda" && el1 == el2 && oldValues[el1]!= newValues[el2] ) {
                        let actionHistory = new CalamityActionHistoryModel();
                        if (oldValues[el1] == null && newValues[el2] != null){
                            let dalFreeText = {
                                user: this.profile.fullName,
                                action: "has updated",
                                field: "Agenda",
                                oldvalue: null,
                                newvalue: newValues[el2].ageShortName,
                                date: new Date()
                            };
                            actionHistory.calFreeText = JSON.stringify(dalFreeText);
                        }
                        else if(oldValues[el1] != null && newValues[el2] == null){
                            let dalFreeText = {
                                user: this.profile.fullName,
                                action: "has updated",
                                field: "Agenda",
                                oldvalue: oldValues[el1].ageShortName,
                                newvalue: null,
                                date: new Date()
                            };
                            actionHistory.calFreeText = JSON.stringify(dalFreeText);
                        }
                        else if (oldValues[el1].ageShortName != newValues[el2].ageShortName) {
                            let dalFreeText = {
                                user: this.profile.fullName,
                                action: "has updated",
                                field: "Agenda",
                                oldvalue: oldValues[el1].ageShortName,
                                newvalue: newValues[el2].ageShortName,
                                date: new Date()
                            };
                            actionHistory.calFreeText = JSON.stringify(dalFreeText);
                        }
                        actionHistory.calCreatedBy = this.profile.fullName;
                        actionHistory.calCreatedDate = new Date();
                        actionHistory.calLastModifiedDate = new Date();
                        actionHistoryList.push(actionHistory);
                    }
                    
                    else if (el1 == "claManagedBy" && el1 == el2&& oldValues[el1]!= newValues[el2]) {
                        let actionHistory = new CalamityActionHistoryModel();
                        if(oldValues[el1] == null && newValues[el2] != null){
                            let dalFreeText = {
                                user: this.profile.fullName,
                                action: "has updated",
                                field: "Assignee",
                                oldvalue: null,
                                newvalue: newValues[el2].fullName,
                                date: new Date()
                            };
                            actionHistory.calFreeText = JSON.stringify(dalFreeText);
                        } else if(oldValues[el1] != null && newValues[el2] == null) {
                            let dalFreeText = {
                                user: this.profile.fullName,
                                action: "has updated",
                                field: "Assignee",
                                oldvalue: oldValues[el1].fullName,
                                newvalue: null,
                                date: new Date()
                            };
                            actionHistory.calFreeText = JSON.stringify(dalFreeText);
                        } else if (oldValues[el1].fullName != newValues[el2].fullName){
                            let dalFreeText = {
                                user: this.profile.fullName,
                                action: "has updated",
                                field: "Assignee",
                                oldvalue: oldValues[el1].fullName,
                                newvalue: newValues[el2].fullName,
                                date: new Date()
                            };
                            actionHistory.calFreeText = JSON.stringify(dalFreeText);
                        }
                        actionHistory.calCreatedBy = this.profile.fullName;
                        actionHistory.calCreatedDate = new Date();
                        actionHistory.calLastModifiedDate = new Date();
                        actionHistoryList.push(actionHistory);
                    }
                    else if (el1 == "claComment" && el1 == el2 && oldValues[el1] != newValues[el2]) {
                    let actionHistory = new CalamityActionHistoryModel();
                    let dalFreeText = {
                        user: this.profile.fullName,
                        action: "has updated",
                        field: "Comment",
                        oldvalue: oldValues[el1],
                        newvalue: newValues[el2],
                        date: new Date()
                    };
                    actionHistory.calFreeText = JSON.stringify(dalFreeText);
                    actionHistory.calCreatedBy = this.profile.fullName;
                    actionHistory.calCreatedDate = new Date();
                    actionHistory.calLastModifiedDate = new Date();
                    actionHistoryList.push(actionHistory);
                }
                else if (el1 == "claOrganisation" && el1 == el2 && oldValues[el1] != newValues[el2]) {
                    let actionHistory = new CalamityActionHistoryModel();
                    let dalFreeText = {
                        user: this.profile.fullName,
                        action: "has updated",
                        field: "Organisation",
                        oldvalue: oldValues[el1],
                        newvalue: newValues[el2],
                        date: new Date()
                    };
                    actionHistory.calFreeText = JSON.stringify(dalFreeText);
                    actionHistory.calCreatedBy = this.profile.fullName;
                    actionHistory.calCreatedDate = new Date();
                    actionHistory.calLastModifiedDate = new Date();
                    actionHistoryList.push(actionHistory);
                }
                else if (el1 == "claContactWith" && el1 == el2 && oldValues[el1] != newValues[el2]) {
                    let actionHistory = new CalamityActionHistoryModel();
                    let dalFreeText = {
                        user: this.profile.fullName,
                        action: "has updated",
                        field: "ContactWith",
                        oldvalue: oldValues[el1],
                        newvalue: newValues[el2],
                        date: new Date()
                    };
                    actionHistory.calFreeText = JSON.stringify(dalFreeText);
                    actionHistory.calCreatedBy = this.profile.fullName;
                    actionHistory.calCreatedDate = new Date();
                    actionHistory.calLastModifiedDate = new Date();
                    actionHistoryList.push(actionHistory);
                }

                });
            }
        });
        return (actionHistoryList)
    }
}